import React, { useState } from "react";
import ReactQuill from "react-quill";
import { useDispatch } from "react-redux";
import {
  removeFeedback,
  updateItemQuestion,
  updateQUestionFeedback,
  updateQuizPointValue,
  updateRequiredChange,
} from "../../Redux/Reducer/FormSlices";

import answerKeyIcon from "../../Assets/answerKeyIcon.png";
import FeedBackModal from "./FeedBackModal/FeedBackModal";
import Addiconfontsizes from "../../Assets/Addiconfontsizes.png";
import reduceiconfontsizes from "../../Assets/reduceiconfontsizes.png";
import editNotificationicon from "../../Assets/editNotificationicon.png";
import deleteNotificationIcon from "../../Assets/deleteNotificationIcon.png";

const ParagraphQuestion = ({
  question,
  questionIndex,
  openQuestion,
  setOpenQuestion,
  module,
  containerIndex,
  id,
  generalSettings,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };

  const [showAnswerKey, setShowAnswerKey] = useState(null);
  //handelAddAnswerKey
  const handelAddAnswerKey = (questionId) => {
    console.log(questionId);
    setShowAnswerKey(questionId);
  };

  const handleRequiredChange = (questionIndex, containerIndex, value) => {
    dispatch(updateRequiredChange({ questionIndex, containerIndex, value }));
  };

  const [isShowFeedbackModal, setShowFeedbackModal] = useState(false);

  const closeFeedbackModal = () => {
    setShowFeedbackModal(!isShowFeedbackModal);
  };

  const [showCorrect, setShowCorrect] = useState("Incorrect answer");
  const handelUpdateFeedBack = (e) => {
    dispatch(
      updateQUestionFeedback({
        questionIndex,
        containerIndex,
        name: e.target.name,
        value: e.target.value,
      })
    );
  };

  //update answer point value in redux
  const handelChangePointValue = (point) => {
    dispatch(updateQuizPointValue({ point }));
  };

  const handelEditFeedBack = () => {
    setShowFeedbackModal(true);
  };

  const handelDeleteFeedBack = (name) => {
    dispatch(removeFeedback({ containerIndex, questionIndex, name }));
  };
  return (
    <>
      <FeedBackModal
        isOpen={isShowFeedbackModal}
        onClose={closeFeedbackModal}
        showCorrect={showCorrect}
        setShowCorrect={setShowCorrect}
        onChange={handelUpdateFeedBack}
        answerFeedback={question}
        type={"paragraph"}
      />
      {showAnswerKey === question.id ? (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
          >
            <div>Edit feedback and points</div>
            <div className="Questionview_container" style={{marginTop:"1rem"}}>
              {questionIndex + 1}.
              <div
                className="Questionview_text"
                dangerouslySetInnerHTML={{ __html: question.question }}
              ></div>
            </div>
            <div
              className="answer-key-component-bottom"
              style={{ marginTop: "1rem" }}
            >
              <div
                className="answer-feedback-text"
                onClick={closeFeedbackModal}
              >
                Add answer feedback
              </div>
              <div className="input-text-sizes">
                <input
                  type="number"
                  placeholder=""
                  name="quizSettings.questionPointValue"
                  className="inputValue-for-form-name"
                  value={generalSettings.quizSettings.questionPointValue || ""}
                  onChange={(e) => handelChangePointValue(e.target.value)}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    justifyContent: "center",
                  }}
                >
                  <img src={Addiconfontsizes} alt="addicon" />
                  <img src={reduceiconfontsizes} alt="reduce" />
                </div>
                <div className="text-sizes-model">Points</div>
              </div>
            </div>
            {question.currentAnswerFeedback !== "" && (
              <div className="show-feedback-container">
                <div className="show-feedback-container-text-container">
                  <div>FEEDBACK FOR CORRECT ANSWERS</div>
                  <div style={{ color: "#8493B2" }}>
                    {question.currentAnswerFeedback}
                  </div>
                </div>
                <div style={{ display: "flex", gap: "1rem" }}>
                  <div onClick={handelEditFeedBack}>
                    <img src={editNotificationicon} alt="" />
                  </div>
                  <div
                    onClick={() =>
                      handelDeleteFeedBack("currentAnswerFeedback")
                    }
                  >
                    <img src={deleteNotificationIcon} alt="" />
                  </div>
                </div>
              </div>
            )}
            {question.inCurrentAnswerFeedback !== "" && (
              <div className="show-feedback-container">
                <div className="show-feedback-container-text-container">
                  <div>FEEDBACK FOR CORRECT ANSWERS</div>
                  <div style={{ color: "#8493B2" }}>
                    {question.inCurrentAnswerFeedback}
                  </div>
                </div>
                <div style={{ display: "flex", gap: "1rem" }}>
                  <div onClick={handelEditFeedBack}>
                    <img src={editNotificationicon} alt="" />
                  </div>
                  <div
                    onClick={() =>
                      handelDeleteFeedBack("inCurrentAnswerFeedback")
                    }
                  >
                    <img src={deleteNotificationIcon} alt="" />
                  </div>
                </div>
              </div>
            )}
            <div className="done-button-currect-answer">
              <button onClick={() => setShowAnswerKey(null)}>Done</button>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="singleQuestion-Container">
            {questionIndex + 1}.
            <ReactQuill
              modules={module}
              theme="snow"
              className={`custom ${
                openQuestion === question.id ? "focus" : ""
              }`}
              onFocus={() => setOpenQuestion(question.id)}
              onBlur={() => setOpenQuestion(null)}
              value={question.question}
              onChange={handleQuestionChange}
            />
          </div>
          <div className="answer-container">{question.placeHolder}</div>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: generalSettings.isQuiz
                ? "space-between"
                : "flex-end",
              marginTop: "2rem",
            }}
          >
            {generalSettings.isQuiz && (
              <div
                onClick={() => handelAddAnswerKey(question.id)}
                style={{
                  display: "flex",
                  gap: "0.71rem",
                  color: "#1B51BB",
                  alignItems: "center",
                  zIndex: 100,
                }}
              >
                <img src={answerKeyIcon} alt="answerKeyIcon" />
                Answer key
              </div>
            )}
            <div className="required-container">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={question.required}
                  onChange={(e) =>
                    handleRequiredChange(
                      questionIndex,
                      containerIndex,
                      e.target.checked
                    )
                  }
                />
                <span className="slider"></span>
              </label>
              <p className="required-text">Required</p>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ParagraphQuestion;
